import { render } from "./CreateVpc.vue?vue&type=template&id=510fd4d6&scoped=true"
import script from "./CreateVpc.vue?vue&type=script&lang=js"
export * from "./CreateVpc.vue?vue&type=script&lang=js"

import "./CreateVpc.vue?vue&type=style&index=0&id=510fd4d6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510fd4d6"]])

export default __exports__